import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AdmissionsEngagementsService } from '../admissions-engagements.service';
import { AdmissionsEngagementsCompletedEngagementsViewPart } from './completed-engagements/completed-engagements-view.part';
import { AdmissionsContactReqFollowUpsViewPart } from './contact-request/contact-request-view.part';
import { AdmissionsEngagementsOpenEngagementsViewPart } from './open-engagements/open-engagements-view.part';
import { AdmissionsFollowUpsFollowUpsViewPart } from './scheduled-follow-ups/scheduled-follow-ups.part';
@Component({
	selector: 'admissions-engagements-views-part',
	standalone: true,
	imports: [
		AdmissionsFollowUpsFollowUpsViewPart,
		AdmissionsContactReqFollowUpsViewPart,
		AdmissionsEngagementsOpenEngagementsViewPart,
		AdmissionsEngagementsCompletedEngagementsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './engagements-views.part.html',
})
export class AdmissionsEngagementsViewsPart implements OnInit {

	public service = inject(AdmissionsEngagementsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}